import * as PIXI from 'pixi.js';
import { Particle } from './Particle';

export class ParticleManager {
  private particles: Particle[] = [];
  private container: PIXI.Container;

  constructor(container: PIXI.Container) {
    this.container = container;
  }

  public createParticles(x: number, y: number, color: number, count: number): void {
    for (let i = 0; i < count; i++) {
      this.particles.push(new Particle(x, y, color, this.container));
    }
  }

  public update(): void {
    this.particles = this.particles.filter(p => {
      const alive = p.update();
      if (!alive) p.destroy();
      return alive;
    });
  }

  public count(): number {
    return this.particles.length;
  }

  public clear(): void {
    this.particles.forEach(p => p.destroy());
    this.particles = [];
  }
}
